<span><fa-icon [icon]="icons.platform(platform)"></fa-icon> {{ platform | titlecase }}</span>
